var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataDesks"},[_c('div',{staticClass:"deskContainer"},_vm._l((_vm.dataDesk[0]),function(element,index){return _c('BaseSmallDesk',{key:index,staticClass:"deskStyle",attrs:{"deskNumber":element.data,"deskSubtitle":element.title,"total":element.total}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }